export default function convertDBtoLinear(db: number) {
  return Math.pow(10, db / 20);
}
